import { useState as s } from "react";
const p = () => {
  const [e, t] = s({
    title: "媒體庫"
  }), n = () => {
    t((r) => ({
      ...r,
      transform: "translateX(0)",
      pointerEvents: "auto",
      opacity: 1
    }));
  }, o = () => {
    t((r) => ({
      ...r,
      transform: "translateX(-100%)",
      pointerEvents: "none",
      opacity: 0
    }));
  };
  return e.onCancel = o, {
    show: n,
    close: o,
    drawerProps: e,
    setDrawerProps: t
  };
};
export {
  p as useSimpleDrawer
};
